module.exports = __webpack_public_path__ + "img/menu-health.44637ba0.svg";